import { createContext, useContext } from 'react';
import type { CommunityFilters } from '../types/communityFilters';
import type { AnalyticsFilterParams } from '../services/analyticsService';

// In B2B mode the analytics dashboard pages (Geo / AI / Reports) read their
// filter state from the single global filter panel in the navbar, exposed here.
// It is ``null`` in the community app, where each analytics page keeps its own
// local date-range control — so consumers can branch on ``null`` to preserve the
// community behaviour unchanged.
export const DashboardFilterContext = createContext<CommunityFilters | null>(null);

export function useDashboardFilters(): CommunityFilters | null {
  return useContext(DashboardFilterContext);
}

// Map the community-feed filter shape onto the analytics query params the
// service expects. Date bounds map straight across; the remaining fields are
// passed through and only serialized into the request when non-empty.
export function communityFiltersToAnalyticsParams(
  f: CommunityFilters,
): AnalyticsFilterParams {
  return {
    start: f.dateStart,
    end: f.dateEnd,
    severities: f.severities,
    status: f.status,
    regions: f.regions,
    userIds: f.userIds,
    myHazardsOnly: f.myHazardsOnly,
    search: f.searchTerm,
    searchField: f.searchField,
  };
}
